export const inClientMode = () => {
  return typeof window !== 'undefined';
};

export const getEnvVariable = (key: string, fallback?: string) => {
  if (inClientMode()) {
    return (window as any)[key] ?? process.env[key] ?? fallback;
  } else {
    return process.env[key] ?? fallback;
  }
};
